<template>
  <button :class="['s-button', { disabled: disabled ||timedDisabled }, type, size]" @click="click">
    <!-- <slot/> -->
    <div class="shade-box" v-if="loading" @click="shadeClick">
    </div>
    <div class="spinner" v-if="loading"></div>
    <slot v-if="!isTiming"></slot>
    <span v-else>{{ remainingSec }}s</span>
  </button>
</template>
<script>
export default {
  name: 'SButton',
  created () {
    this.originText = this.$slots.default[0].text
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    duration: {
      type: Number,
      required: false,
      default: 60
    },
    timed: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: 'default'
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      originText: '',
      timedDisabled: false,
      isTiming: false,
      remainingSec: 60
    }
  },
  watch: {
    timed (timed) {
      console.log(timed, this.timed)
      if (this.timed) {
        this.startTiming()
      }
    }
  },
  methods: {
    click () {
      if (!this.disabled && !this.timedDisabled) {
        this.$emit('click')
      }
    },
    shadeClick (e) {
      e.stopPropagation()
    },
    updateTimeText (remainingSec) {
      if (remainingSec <= 0) {
        // this.$slots.default = [this.$createElement('div', [this.originText])]
        // this.$forceUpdate()
        this.timedDisabled = false
        this.isTiming = false
        return
      }
      console.log(remainingSec)
      // this.$slots.default = [this.$createElement('div', [`${remainingSec}s`])]
      // this.$forceUpdate()
      this.remainingSec = remainingSec
      console.log('forceUpdate')
      setTimeout(() => {
        this.updateTimeText(remainingSec - 1)
      }, 1000)
    },
    startTiming () {
      this.timedDisabled = true
      this.isTiming = true
      this.updateTimeText(this.duration)
    },
    endTiming () {
      this.$slots.default = [this.$createElement('div', [this.originText])]
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="less" scoped>
.s-button {
    width: 205px;
    height: 50px;
    background-color: #912a22;
    border-radius: 2px;
    font-family: MicrosoftSansSerif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #fff;
    outline: none;
    border: 0;
    cursor: pointer;
    &.large {
      width: 460px;
      height: 52px;
    }
    &.disabled {
      opacity: .5;
      cursor: not-allowed;
    }
    &.gray {
      background-color: #837574;
    }
     >.shade-box {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 1;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: #ccc;
      opacity: .5;
    }
    >.spinner {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-top: 1px solid #fff;
        border-left: 1px solid #bbb;
        border-right: 1px solid #bbb;
        border-bottom: 1px solid #bbb;
        border-radius: 50%;
        animation: infiniteRotate .7s linear infinite;
        margin-right: 5px;
        vertical-align: bottom;
    }
}
@media screen and (max-width: 750px) {
  .s-button {
    font-size: 2.1333333333333333rem /* 16/7.5 */;
    height: 6.6667rem /* 50/7.5 */;
    &.large {
      width: 70.6667rem;
      height: 8.2667rem;
    }
  }
}
</style>
